<template>
  <div class="frame12_body">
    <div class="frame12">
      <div class="frame12_top">
        盈利能力-利润率
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame12_close"
        />
      </div>
      <div class="frame12_content">
        <div class="frame12_content_title">毛利率</div>
        <div class="frame12_content_text">
          【释义】：销售毛利率是毛利占销售收入的百分比，反映1元销售收入扣减生产成本后还有多少盈余可以用以支付企业运营费用并最终形成收益。
        </div>
        <div class="frame12_content_text">【算法】：毛利率=毛利润/营业收入=（营业收入-营业成本）/营业收入*100%</div>
        <div class="frame12_content_text">【单位】：%</div>
      </div>
      <div class="frame12_content">
        <div class="frame12_content_title">净利率</div>
        <div class="frame12_content_text">
          【释义】：销售净利率是指净利润与销售收入的百分比，反映整个企业销售收入的收益水平。由于“销售收入”是合并报表的营业收入（即包含少数股东的部分），因此“净利润”采用全部净利润（即包含少数股东权益）。  
        </div>
        <div class="frame12_content_text">
          【算法】：净利率=净利润/营业收入*100% 
        </div>
        <div class="frame12_content_text">【单位】：%</div>
      </div>
      <div class="frame12_content">
        <div class="frame12_content_title">营业利润率</div>
        <div class="frame12_content_text">
          【释义】：营业利润率是指经营所得的营业利润占销货净额的百分比。指标综合反映一个企业或者行业的营业效率。指标值越高，代表企业的盈能力越强。 
        </div>
        <div class="frame12_content_text">
          【算法】：营业利润率=营业利润/营业总收入*100% （一般企业）营业总收入=营业收入+利息收入+已赚保费+手续费及佣金收入 （银行、证券、保险）营业总收入=营业收入  
        </div>
        <div class="frame12_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame12_close() {
      this.$emit("frame12_close");
    },
  },
};
</script>

<style scoped>
.frame12_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame12 {
  width: 448px;
  height: 800px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame12_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame12_content {
  margin-top: 28px;
}
.frame12_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame12_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame12_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>